import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", {
  class: "kakugo w100",
  style: {"height":"120px","top":"0","z-index":"10"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "ofh w80 fl",
    style: {"margin-top":"25px"}
  }, [
    /*#__PURE__*/_createElementVNode("h4", {
      class: "fs20 ls1 fl",
      style: {"margin-left":"80px","margin-top":"24px"}
    }, [
      /*#__PURE__*/_createElementVNode("span", null, "ユーザー設定")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "clear" })
], -1)
const _hoisted_3 = {
  key: 0,
  class: "w100",
  style: {"height":"50px","text-align":"middle","border-bottom":"1px solid #ddd"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (!_ctx.isSP)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.rm.userInfo)
          ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
              _createVNode(_component_router_link, { to: "/settings/user" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(`roomsCategoryTab pointer centered fl ${_ctx.selectedTab == 'settings' ? 'selected fw600' : ''}`),
                    style: {"width":"160px"}
                  }, " ユーザー情報 ", 2)
                ]),
                _: 1
              }),
              (_ctx.showRoomsSettings())
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/settings/rooms"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(`roomsCategoryTab pointer centered fl ${_ctx.selectedTab == 'rooms' ? 'selected fw600' : ''}`),
                        style: {"width":"180px"}
                      }, " 調整ページ全般 ", 2)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showMailSettings())
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: "/settings/mail"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(`roomsCategoryTab pointer centered fl ${_ctx.selectedTab == 'mail' ? 'selected fw600' : ''}`),
                        style: {"width":"160px"}
                      }, " メール全般 ", 2)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showScheduleSettings())
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    to: "/settings/schedule"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(`roomsCategoryTab pointer centered fl ${_ctx.selectedTab == 'schedule' ? 'selected fw600' : ''}`),
                        style: {"width":"180px"}
                      }, " カレンダー全般 ", 2)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showSecuritySettings())
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 3,
                    to: "/settings/security"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(`roomsCategoryTab pointer centered fl ${_ctx.selectedTab == 'security' ? 'selected fw600' : ''}`),
                        style: {"width":"180px"}
                      }, " セキュリティ ", 2)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 4,
                    to: "/settings/forms"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(`roomsCategoryTab pointer centered fl ${_ctx.selectedTab == 'forms' ? 'selected fw600' : ''}`),
                        style: {"width":"140px"}
                      }, " フォーム ", 2)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _hoisted_4
      ]))
    : _createCommentVNode("", true)
}